import {
  LoaderCircle,
  CircleCheck,
  Bookmark,
  Hourglass,
  XCircle,
  Clock,
  PlusCircle,
  LucideIcon
} from 'lucide-react';

import { GuestStatus, SurveyResponses } from 'types/guest.types';
import { Session } from 'types/event.types';
import { Question, QUESTION_TYPE } from 'types/question.types';
import { QuestionResponse } from 'types/question-response.types';

export const getDisplayTextForStatus = (status: GuestStatus): string => {
  switch (status) {
    case GuestStatus.CONFIRMED:
      return 'Going';
    case GuestStatus.INTERESTED:
      return 'Maybe';
    case GuestStatus.WAITLISTED:
      return 'Waitlisted';
    case GuestStatus.CANCELLED:
      return 'Not going';
    case GuestStatus.CONFIRMED_WITH_INCOMPLETE_SURVEY:
      return 'Incomplete';
    case GuestStatus.ACTION_REQUIRED:
      return 'Pending';
    case GuestStatus.INVITED:
      return 'Invited';
    default:
      return 'None';
  }
};

export const getIconForStatus = (status: GuestStatus): LucideIcon => {
  switch (status) {
    case GuestStatus.CONFIRMED:
      return CircleCheck;
    case GuestStatus.INTERESTED:
      return Bookmark;
    case GuestStatus.WAITLISTED:
      return Hourglass;
    case GuestStatus.CANCELLED:
      return XCircle;
    case GuestStatus.CONFIRMED_WITH_INCOMPLETE_SURVEY:
      return LoaderCircle;
    case GuestStatus.ACTION_REQUIRED:
      return Clock;
    case GuestStatus.INVITED:
      return PlusCircle;
    default:
      return PlusCircle;
  }
};

// sessionId -> session
export type SessionMap = Record<number, Session>;
export const toSessionMap = (sessions: Session[]): SessionMap => {
  return sessions.reduce(
    (mapping: SessionMap, session: Session): SessionMap => ({ ...mapping, [session.id]: session }),
    {}
  );
};

export const formatSurveyResponses = (
  questions: Question[],
  responses: SurveyResponses
): Record<string, any> => {
  return questions.reduce((acc, question) => {
    if (!question.id) return acc;
    return { ...acc, [question.id]: responses[question.id]?.response };
  }, {});
};

/**
 *
 * @description formats the question response as a string for the UI
 */
export const formatResponse = (response: QuestionResponse): string => {
  switch (response.type) {
    case QUESTION_TYPE.RADIO:
      return response.selectedOption || response.otherValue || 'N/A';
    case QUESTION_TYPE.CHECK:
      return response.otherValue
        ? [...response.selectedOptions, response.otherValue].join(', ')
        : response.selectedOptions.join(', ');
    case QUESTION_TYPE.LONG:
    case QUESTION_TYPE.LINEAR_SCALE:
    case QUESTION_TYPE.NPS:
    case QUESTION_TYPE.SATISFACTION:
    case QUESTION_TYPE.CONNECTION:
    case QUESTION_TYPE.RETENTION:
      return response.value || 'N/A';
    default:
      return 'N/A';
  }
};
